import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import TicketsResource from 'flow/api/omnitickets';
import Actions from 'flow/actions';
import { Map, fromJS, List } from 'immutable';
import { REGEXP_POSSIBLE_MENTION_STRICT } from 'flow/utils/message-utils';
import { TICKET_FAILED_EVENTS_LOCAL_STORAGE_KEY } from 'flow/utils/browser-utils';
import { networkErrorDispatcher } from 'flow/actions/app-actions';
import { onTicketWriteRefused } from 'flow/actions/ticket-actions';
import { ticketRequestError } from 'flow/utils/ticket-utils';
import { setTicketMessageStatus, fetchTicketMessage } from 'flow/actions/tickets-action';
import { selectChatUserKey, selectContact, selectExtensions, selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { selectMembers, selectNonMembersAreMentionable } from 'flow/selectors/TicketsSelectors';
import { selectEvents, selectTicketMessageAttachments } from 'flow/selectors/TicketEventSelectors';
import { PREFIX_MESSAGE_PLACEHOLDER_KEY } from 'flow/types/TicketEventData';
import AttachmentUploadError, { ERROR_GENERIC, FILE_NOT_ACCEPTED, FILE_SIZE_EXCEEDED, FILE_TYPE_NOT_ALLOWED } from './Attachments/AttachmentUploadError';
import { browserSupportStorage } from 'flow/utils/browser-storage-utils';
import wrappedLocalStorage from 'flow/utils/local-storage-utils';
import { escapeRegExp } from 'flow/utils/message-utils';
import { getContactName } from 'flow/utils/contact-utils';
export var fetchEmailRecipients = function fetchEmailRecipients(ticketKey) {
  return new Promise(function (resolve, reject) {
    TicketsResource.fetchEmailRecipients({
      onResult: function onResult(data) {
        resolve(data);
      },
      onClientError: function onClientError(error) {
        reject(new Error("".concat(error === null || error === void 0 ? void 0 : error.status)));
      },
      onError: function onError(error) {
        reject(new Error("".concat(error === null || error === void 0 ? void 0 : error.status)));
      }
    }, ticketKey);
  });
};
export var MAX_ATTACHMENT_SIZE_DEFAULT = 20971520;
var fetchAttachmentUploadUrl = function fetchAttachmentUploadUrl(ticketKey, channel, fileName, fileSize, mimeType) {
  return new Promise(function (resolve, reject) {
    TicketsResource.getUploadUrl({
      onResult: function onResult(data) {
        resolve(data);
      },
      onClientError: function onClientError(error) {
        reject(error);
      },
      onError: function onError(error) {
        reject(error);
      }
    }, ticketKey, fileName, channel, fileSize, mimeType);
  });
};
export var uploadAttachmentAndGetAttachmentData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(ticketKey, channel, attachment) {
    var fileName, file, responseData, _responseData, url, path, maxSize, isAllowedType, isAccepted, _t, _t2;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (attachment !== null && attachment !== void 0 && attachment.file) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", null);
        case 1:
          fileName = attachment.name;
          file = attachment.file;
          _context.prev = 2;
          _context.next = 3;
          return fetchAttachmentUploadUrl(ticketKey, channel, fileName, file.size, file.type);
        case 3:
          responseData = _context.sent;
          _context.next = 5;
          break;
        case 4:
          _context.prev = 4;
          _t = _context["catch"](2);
          throw new AttachmentUploadError(ERROR_GENERIC, _t === null || _t === void 0 ? void 0 : _t.message);
        case 5:
          _responseData = responseData, url = _responseData.url, path = _responseData.path, maxSize = _responseData.maxSize, isAllowedType = _responseData.isAllowedType, isAccepted = _responseData.isAccepted; // maxSize = if the file is the correct type, but is too big
          // isAllowedType = if the file type is supported
          // isAccepted = if the file is the correct type and size
          if (!maxSize) {
            _context.next = 6;
            break;
          }
          throw new AttachmentUploadError(FILE_SIZE_EXCEEDED, 'File size exceeded');
        case 6:
          if (isAllowedType) {
            _context.next = 7;
            break;
          }
          throw new AttachmentUploadError(FILE_TYPE_NOT_ALLOWED, 'File type not allowed');
        case 7:
          if (isAccepted) {
            _context.next = 8;
            break;
          }
          throw new AttachmentUploadError(FILE_NOT_ACCEPTED, 'File not accepted');
        case 8:
          _context.prev = 8;
          _context.next = 9;
          return fetch(url, {
            method: 'PUT',
            body: file,
            headers: {
              'Content-Type': 'application/octet-stream'
            }
          });
        case 9:
          _context.next = 11;
          break;
        case 10:
          _context.prev = 10;
          _t2 = _context["catch"](8);
          throw new AttachmentUploadError(ERROR_GENERIC, _t2 === null || _t2 === void 0 ? void 0 : _t2.message);
        case 11:
          return _context.abrupt("return", {
            fileName: fileName,
            fileSize: file.size,
            fileType: file.type,
            path: path,
            aspectRatio: attachment.aspectRatio
          });
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 4], [8, 10]]);
  }));
  return function uploadAttachmentAndGetAttachmentData(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchTicketAttachmentRestrictions = function fetchTicketAttachmentRestrictions() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsResource.getFileRestrictions({
        onResult: function onResult(response) {
          dispatch(setAttachmentRestrictions(response));
          resolve(response);
        },
        onClientError: function onClientError(error) {
          reject(error);
        },
        onError: function onError(error) {
          networkErrorDispatcher(dispatch);
          reject(error);
        }
      });
    });
  };
};
var setAttachmentRestrictions = function setAttachmentRestrictions(data) {
  return function (dispatch) {
    return dispatch({
      type: Actions.SET_TICKET_ATTACHMENT_SEND_RESTRICTIONS,
      data: data
    });
  };
};
export var getFileExtensionWithDot = function getFileExtensionWithDot(fileName) {
  if (!fileName) return '';
  var lastDotIndex = fileName.lastIndexOf('.');
  return lastDotIndex !== -1 ? fileName.slice(lastDotIndex) : '';
};
var getSendMessageActionFromDTOSubtype = function getSendMessageActionFromDTOSubtype(dtoSubtype) {
  if (dtoSubtype === 'OmniEmailMessageTicketEvent') return TicketsResource.sendEmailMessage;
  if (dtoSubtype === 'OmniWhatsAppMessageTicketEvent') return TicketsResource.sendWhatsAppMessage;
  if (dtoSubtype === 'OmniInternalNoteTicketEvent') return TicketsResource.addInternalNote;
  if (dtoSubtype === 'OmniSmsNoteTicketEvent') return TicketsResource.sendSMS;
  if (dtoSubtype === 'OmniWhatsAppTemplateMessageTicketEvent') return TicketsResource.sendWhatsAppTemplateMessage;
  return undefined;
};
var getChannelFromDTOSubtype = function getChannelFromDTOSubtype(dtoSubtype) {
  if (dtoSubtype === 'OmniEmailMessageTicketEvent') return 'email';
  if (dtoSubtype === 'OmniWhatsAppMessageTicketEvent' || dtoSubtype === 'OmniWhatsAppTemplateMessageTicketEvent') return 'whatsapp';
  if (dtoSubtype === 'OmniInternalNoteTicketEvent') return 'internal';
  if (dtoSubtype === 'OmniSmsNoteTicketEvent') return 'sms';
  return undefined;
};
export var tryResendTicketMessage = function tryResendTicketMessage(ticketKey, messageKey) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _selectEvents, _selectTicketMessageA;
      var messageEventBase, attachment, eventWithUploadedAttachmentData, channel;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            messageEventBase = (_selectEvents = selectEvents(getState(), ticketKey)) === null || _selectEvents === void 0 || (_selectEvents = _selectEvents.find(function (event) {
              return event.get('key') === messageKey;
            })) === null || _selectEvents === void 0 ? void 0 : _selectEvents["delete"]('key');
            attachment = (_selectTicketMessageA = selectTicketMessageAttachments(getState(), ticketKey, messageKey)) === null || _selectTicketMessageA === void 0 ? void 0 : _selectTicketMessageA.first();
            eventWithUploadedAttachmentData = attachment !== null && attachment !== void 0 && attachment.get('path') ? fromJS({
              attachments: List([attachment])
            }).merge(messageEventBase) : messageEventBase; // if attachment path property has a value, the attachment has been uploaded to the bucket,
            // and we should add this data to the event that is sent to the API.
            channel = getChannelFromDTOSubtype(messageEventBase === null || messageEventBase === void 0 ? void 0 : messageEventBase.get('DTOSubtype'));
            dispatch(setTicketMessageStatus(ticketKey, messageKey, 'SENDING'));
            // Not caught here: sendMessage has already marked the placeholder failed,
            // and the rejection is what tells the caller to explain the refusal.
            _context2.next = 1;
            return dispatch(sendMessage(ticketKey, messageKey, channel, eventWithUploadedAttachmentData === null || eventWithUploadedAttachmentData === void 0 ? void 0 : eventWithUploadedAttachmentData.toJS(), null, null,
            //event already saved when resend action is presented
            true));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var getAttachmentPlaceholderFriendly = function getAttachmentPlaceholderFriendly(attachmentData) {
  if (!attachmentData) return null;
  return {
    fileName: attachmentData.name,
    fileSize: attachmentData.file.size,
    fileType: attachmentData.file.type,
    aspectRatio: attachmentData.aspectRatio
  };
};
var handleAttachmentUpload = function handleAttachmentUpload(ticketKey, channel, messagePlaceholderKey, attachmentToUpload) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var attachmentApiData;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 1;
            return uploadAttachmentAndGetAttachmentData(ticketKey, channel, attachmentToUpload);
          case 1:
            attachmentApiData = _context3.sent;
            if (attachmentApiData) {
              dispatch(onUploadAttachmentStageCompleted(ticketKey, messagePlaceholderKey, attachmentApiData));
            }
            return _context3.abrupt("return", attachmentApiData);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var sendMessage = function sendMessage(ticketKey, messagePlaceholderKey, channel, messageDTOBase, attachmentToUpload, placeholderEventToSaveLocallyOnFail, isRetryAttempt) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var attachmentApiData, messageDTOForApi, sendMessageAction, _t3;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 1;
            return dispatch(handleAttachmentUpload(ticketKey, channel, messagePlaceholderKey, attachmentToUpload));
          case 1:
            attachmentApiData = _context4.sent;
            _context4.next = 4;
            break;
          case 2:
            _context4.prev = 2;
            _t3 = _context4["catch"](0);
            if (!(_t3 instanceof AttachmentUploadError)) {
              _context4.next = 3;
              break;
            }
            if (_t3.code === FILE_TYPE_NOT_ALLOWED || _t3.code === FILE_NOT_ACCEPTED || _t3.code === FILE_SIZE_EXCEEDED) {
              dispatch(onUnrecoverableSendError(ticketKey, messagePlaceholderKey));
              // If error code matches any of the above, we remove the placeholder message as any
              // resend attempts are guaranteed to fail
            } else {
              dispatch(onMessageFailedToSend(ticketKey, messagePlaceholderKey, placeholderEventToSaveLocallyOnFail));
            }
            throw _t3;
          case 3:
            dispatch(onMessageFailedToSend(ticketKey, messagePlaceholderKey, placeholderEventToSaveLocallyOnFail));
            networkErrorDispatcher(dispatch);
            //Should never end up here, I believe.
            return _context4.abrupt("return");
          case 4:
            messageDTOForApi = _objectSpread(_objectSpread({}, messageDTOBase), attachmentApiData ? {
              attachments: [attachmentApiData]
            } : {});
            sendMessageAction = getSendMessageActionFromDTOSubtype(messageDTOForApi.DTOSubtype); // A failed send marks its placeholder and also rejects, so the
            // caller hears about it. That is what lets useTicketAction tell the
            // user when the backend refused the message.
            _context4.next = 5;
            return new Promise(function (resolve, reject) {
              var onSendFailed = function onSendFailed(request) {
                dispatch(onMessageFailedToSend(ticketKey, messagePlaceholderKey, placeholderEventToSaveLocallyOnFail));
                reject(ticketRequestError(request));
              };
              sendMessageAction({
                onResult: function onResult(data) {
                  // The send response body is plain text. For email we
                  // already composed the HTML locally (reply + signature),
                  // so carry it into the stored event to render HTML
                  // immediately — otherwise the plain response shows for a
                  // frame before the canonical HTML version is fetched.
                  var reconciledData = data.DTOSubtype === 'OmniEmailMessageTicketEvent' && messageDTOForApi.message ? _objectSpread(_objectSpread({}, data), {}, {
                    message: messageDTOForApi.message
                  }) : data;
                  dispatch(onMessageSentSuccess(ticketKey, messagePlaceholderKey, reconciledData, isRetryAttempt));
                  resolve();
                },
                onError: onSendFailed,
                onClientError: function onClientError(request) {
                  dispatch(onTicketWriteRefused(ticketKey, request));
                  onSendFailed(request);
                }
              }, ticketKey, messageDTOForApi);
            });
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 2]]);
    }));
    return function (_x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getPlaceholderMessageEventBase = function getPlaceholderMessageEventBase(baseEvent, placeholderKey, attachmentData) {
  return function (_dispatch, getState) {
    var ownExtensionKey = selectOwnExtensionKey(getState());
    return _objectSpread(_objectSpread({}, baseEvent), {}, {
      sender: ownExtensionKey,
      senderData: getSenderDataForPlaceholderMessage(ownExtensionKey),
      key: placeholderKey,
      status: 'SENDING',
      attachments: attachmentData ? [getAttachmentPlaceholderFriendly(attachmentData)] : null
    });
  };
};
export var sendInternalNote = function sendInternalNote(ticketKey, message, attachmentDataFromInput, pickedMentions) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var mentions, internalNoteEventBase, placeholderKey, placeholderInternalNoteDTO;
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            mentions = createMentionDTO(getState(), ticketKey, message, pickedMentions) || List();
            internalNoteEventBase = {
              DTOSubtype: 'OmniInternalNoteTicketEvent',
              message: message,
              stylings: mentions
            };
            placeholderKey = "".concat(PREFIX_MESSAGE_PLACEHOLDER_KEY, "-").concat(Date.now());
            placeholderInternalNoteDTO = _objectSpread(_objectSpread({}, dispatch(getPlaceholderMessageEventBase(internalNoteEventBase, placeholderKey, attachmentDataFromInput))), {}, {
              DTOSubtype: 'OmniInternalNoteTicketEvent'
            });
            dispatch(addPlaceholderEventToStore(ticketKey, placeholderInternalNoteDTO));
            _context5.next = 1;
            return dispatch(sendMessage(ticketKey, placeholderKey, 'internal', internalNoteEventBase, attachmentDataFromInput, placeholderInternalNoteDTO));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var escapeHtmlForEmail = function escapeHtmlForEmail(text) {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

// With a signature the reply is composed as HTML and declared 'rich'; the
// ticket service stores a stripped plaintext copy for mobile and the email
// service sends it as BodyType.Html. Without a signature the reply is sent
// as plain text declared 'plain', byte-identical to the pre-signature
// behavior, so customers without the feature flag are entirely unaffected.
export var buildEmailBody = function buildEmailBody(plainText, signature) {
  if (!signature) return {
    message: plainText,
    messageContentType: 'plain'
  };
  var escapedBody = escapeHtmlForEmail(plainText).replace(/\n/g, '<br>');
  return {
    message: escapedBody ? "".concat(escapedBody, "<br>").concat(signature) : signature,
    messageContentType: 'rich'
  };
};
export var onSendEmailRequested = function onSendEmailRequested(ticketKey, message, attachmentDataFromInput, emailSignature) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var body, emailEventBase, placeholderKey, placeholderEmailDTO;
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            body = buildEmailBody(message !== null && message !== void 0 ? message : '', emailSignature);
            emailEventBase = {
              DTOSubtype: 'OmniEmailMessageTicketEvent',
              message: body.message,
              messageContentType: body.messageContentType
            };
            placeholderKey = "".concat(PREFIX_MESSAGE_PLACEHOLDER_KEY, "-").concat(Date.now());
            placeholderEmailDTO = _objectSpread(_objectSpread({}, dispatch(getPlaceholderMessageEventBase(emailEventBase, placeholderKey, attachmentDataFromInput))), {}, {
              DTOSubtype: 'OmniEmailMessageTicketEvent'
            });
            dispatch(addPlaceholderEventToStore(ticketKey, placeholderEmailDTO));
            _context6.next = 1;
            return dispatch(sendMessage(ticketKey, placeholderKey, 'email', emailEventBase, attachmentDataFromInput, placeholderEmailDTO));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x0) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var onSendWhatsAppMessageRequested = function onSendWhatsAppMessageRequested(ticketKey, message, attachmentDataFromInput) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch) {
      var _attachmentDataFromIn, _attachmentDataFromIn2;
      var whatsAppEventBase, containsAudioAttachment, placeholderKey, placeholderWhatsAppEvent, placeholderKey2, placeholderEventWithTextOnly, whatsAppEventBaseNoMessage, placeholderEventWithAudioAttachmentOnly, textSendError, _t4;
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            whatsAppEventBase = {
              DTOSubtype: 'OmniWhatsAppMessageTicketEvent',
              message: message
            };
            containsAudioAttachment = (_attachmentDataFromIn = attachmentDataFromInput === null || attachmentDataFromInput === void 0 || (_attachmentDataFromIn2 = attachmentDataFromInput.file) === null || _attachmentDataFromIn2 === void 0 || (_attachmentDataFromIn2 = _attachmentDataFromIn2.type) === null || _attachmentDataFromIn2 === void 0 ? void 0 : _attachmentDataFromIn2.startsWith('audio')) !== null && _attachmentDataFromIn !== void 0 ? _attachmentDataFromIn : false;
            placeholderKey = "".concat(PREFIX_MESSAGE_PLACEHOLDER_KEY, "-").concat(Date.now()); // About if below:
            // When we send audio attachments in WhatsApp messages, we send them as type AUDIO (ish).
            // This makes it so that the audio can be played directly in the recipient's WhatsApp app.
            // One quirk with this, however, is that WhatsApp discards the message text in these types of messages.
            // So, when the user sends an audio attachment AND text, we send two events:
            // First, a WhatsApp message event with the text, but without the audio attachment.
            // Second, a WhatsApp message event with audio attachment, but no text.
            if (!(!containsAudioAttachment || containsAudioAttachment && !message)) {
              _context7.next = 2;
              break;
            }
            placeholderWhatsAppEvent = _objectSpread(_objectSpread({}, dispatch(getPlaceholderMessageEventBase(whatsAppEventBase, placeholderKey, attachmentDataFromInput))), {}, {
              direction: 'OUTGOING',
              DTOSubtype: 'OmniWhatsAppMessageTicketEvent'
            });
            dispatch(addPlaceholderEventToStore(ticketKey, placeholderWhatsAppEvent));
            _context7.next = 1;
            return dispatch(sendMessage(ticketKey, placeholderKey, 'whatsapp', whatsAppEventBase, attachmentDataFromInput, placeholderWhatsAppEvent));
          case 1:
            _context7.next = 8;
            break;
          case 2:
            placeholderKey2 = "".concat(PREFIX_MESSAGE_PLACEHOLDER_KEY, "-").concat(Date.now() + 1); //+1 to ensure that the key is different from the key used for the first event
            placeholderEventWithTextOnly = _objectSpread(_objectSpread({}, dispatch(getPlaceholderMessageEventBase(whatsAppEventBase, placeholderKey))), {}, {
              direction: 'OUTGOING',
              DTOSubtype: 'OmniWhatsAppMessageTicketEvent'
            }); // Second event: with attachment, no message
            whatsAppEventBaseNoMessage = {
              DTOSubtype: 'OmniWhatsAppMessageTicketEvent'
            };
            placeholderEventWithAudioAttachmentOnly = _objectSpread(_objectSpread({}, dispatch(getPlaceholderMessageEventBase(whatsAppEventBaseNoMessage, placeholderKey2, attachmentDataFromInput))), {}, {
              direction: 'OUTGOING',
              DTOSubtype: 'OmniWhatsAppMessageTicketEvent'
            });
            dispatch(addPlaceholderEventToStore(ticketKey, placeholderEventWithTextOnly));
            dispatch(addPlaceholderEventToStore(ticketKey, placeholderEventWithAudioAttachmentOnly));

            // Both placeholders are on screen already, and the sends stay in this
            // order because the text has to arrive before the audio. So a failed
            // text send is held rather than thrown: without the second send its
            // placeholder would sit at SENDING for good, with no failed state and
            // so no way to retry it.
            _context7.prev = 3;
            _context7.next = 4;
            return dispatch(sendMessage(ticketKey, placeholderKey, 'whatsapp', whatsAppEventBase, undefined, placeholderEventWithTextOnly));
          case 4:
            _context7.next = 6;
            break;
          case 5:
            _context7.prev = 5;
            _t4 = _context7["catch"](3);
            textSendError = _t4;
          case 6:
            _context7.next = 7;
            return dispatch(sendMessage(ticketKey, placeholderKey2, 'whatsapp', whatsAppEventBaseNoMessage, attachmentDataFromInput, placeholderEventWithAudioAttachmentOnly));
          case 7:
            if (!textSendError) {
              _context7.next = 8;
              break;
            }
            throw textSendError;
          case 8:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[3, 5]]);
    }));
    return function (_x1) {
      return _ref7.apply(this, arguments);
    };
  }();
};
export var sendSMSMessage = function sendSMSMessage(ticketKey, message, attachmentDataFromInput) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(dispatch) {
      var smsEventBase, placeholderKey, placeholderSmsEvent;
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            smsEventBase = {
              DTOSubtype: 'OmniSmsNoteTicketEvent',
              message: message
            };
            placeholderKey = "".concat(PREFIX_MESSAGE_PLACEHOLDER_KEY, "-").concat(Date.now());
            placeholderSmsEvent = _objectSpread(_objectSpread({}, dispatch(getPlaceholderMessageEventBase(smsEventBase, placeholderKey, attachmentDataFromInput))), {}, {
              direction: 'OUTGOING',
              DTOSubtype: 'OmniSmsNoteTicketEvent'
            });
            dispatch(addPlaceholderEventToStore(ticketKey, placeholderSmsEvent));
            _context8.next = 1;
            return dispatch(sendMessage(ticketKey, placeholderKey, 'sms', smsEventBase, attachmentDataFromInput, placeholderSmsEvent));
          case 1:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x10) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var addPlaceholderEventToStore = function addPlaceholderEventToStore(ticketKey, placeholderEvent) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_EVENT,
      ticketKey: ticketKey,
      eventData: placeholderEvent
    });
  };
};
var onMessageSentSuccess = function onMessageSentSuccess(ticketKey, placeholderKey, eventData, attemptDeleteFromLocalStorage) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_EVENT,
      placeholderKeyToRemove: placeholderKey,
      ticketKey: ticketKey,
      eventData: eventData
    });
    // The send response carries only the plain-text body; email messages
    // also have an HTML (rich) version that is not included here. Fetch the
    // full message so the just-sent email renders as HTML immediately,
    // rather than showing plain text until the next full events refresh.
    // Mirrors the incoming-message handling that fetches the HTML version.
    if (eventData.DTOSubtype === 'OmniEmailMessageTicketEvent') {
      void dispatch(fetchTicketMessage(ticketKey, eventData.key));
    }
    if (attemptDeleteFromLocalStorage) {
      deleteFailedMessageEventFromLocalStorage(ticketKey, placeholderKey);
    }
  };
};
var onUnrecoverableSendError = function onUnrecoverableSendError(ticketKey, messageKey) {
  return function (dispatch) {
    dispatch(removeFailedPlaceholderMessageEvent(ticketKey, messageKey));
  };
};
export var removeFailedPlaceholderMessageEvent = function removeFailedPlaceholderMessageEvent(ticketKey, messageKey) {
  return function (dispatch) {
    dispatch({
      type: Actions.REMOVE_TICKET_EVENT,
      ticketKey: ticketKey,
      eventKey: messageKey
    });
    deleteFailedMessageEventFromLocalStorage(ticketKey, messageKey);
  };
};
var getTicketFailedEventsDataFromLocalStorage = function getTicketFailedEventsDataFromLocalStorage() {
  if (!browserSupportStorage()) return {};
  var stored = wrappedLocalStorage.getItem(TICKET_FAILED_EVENTS_LOCAL_STORAGE_KEY);
  if (!stored) return {};
  try {
    return JSON.parse(stored);
  } catch (_unused) {
    return {};
  }
};
var saveFailedPlaceholderEventsRootObject = function saveFailedPlaceholderEventsRootObject(rootObject) {
  if (!browserSupportStorage()) return;
  wrappedLocalStorage.setItem(TICKET_FAILED_EVENTS_LOCAL_STORAGE_KEY, JSON.stringify(rootObject));
};
var deleteFailedMessageEventFromLocalStorage = function deleteFailedMessageEventFromLocalStorage(ticketKey, placeholderKey) {
  try {
    if (!browserSupportStorage()) return;
    var rootObject = getTicketFailedEventsDataFromLocalStorage();
    if (!rootObject[ticketKey]) return;
    delete rootObject[ticketKey][placeholderKey];
    if (Object.keys(rootObject[ticketKey]).length === 0) {
      delete rootObject[ticketKey];
    }
    saveFailedPlaceholderEventsRootObject(rootObject);
  } catch (error) {
    return;
  }
};
var saveFailedMessageEventToLocalStorage = function saveFailedMessageEventToLocalStorage(ticketKey, placeholderKey, placeholderMessageEvent) {
  try {
    if (!browserSupportStorage()) return;
    var rootObject = getTicketFailedEventsDataFromLocalStorage();
    if (!rootObject[ticketKey]) {
      rootObject[ticketKey] = {};
    }
    var ticketKeys = Object.keys(rootObject);
    if ((ticketKeys === null || ticketKeys === void 0 ? void 0 : ticketKeys.length) >= 5) {
      // Remove the first (oldest) ticketKey and its entries
      delete rootObject[ticketKeys[0]];
    }

    // If the current ticketKey contains 10 or more entries, remove the first (oldest) entry
    var failedEventsPlaceholderData = Object.keys(rootObject[ticketKey]);
    if ((failedEventsPlaceholderData === null || failedEventsPlaceholderData === void 0 ? void 0 : failedEventsPlaceholderData.length) >= 10) {
      delete rootObject[ticketKey][failedEventsPlaceholderData[0]];
    }
    rootObject[ticketKey][placeholderKey] = placeholderMessageEvent;
    saveFailedPlaceholderEventsRootObject(rootObject);
  } catch (_error) {
    return;
  }
};
var getPlaceholderEventRecordsFromLocalStorage = function getPlaceholderEventRecordsFromLocalStorage(ticketKey) {
  try {
    if (!browserSupportStorage()) return null;
    var rootObject = getTicketFailedEventsDataFromLocalStorage();
    if (!rootObject[ticketKey]) return null;
    return rootObject[ticketKey];
  } catch (_error) {
    return null;
  }
};
export var getPlaceholderEventsFromLocalStorage = function getPlaceholderEventsFromLocalStorage(ticketKey) {
  try {
    var eventRecords = getPlaceholderEventRecordsFromLocalStorage(ticketKey);
    if (!eventRecords) return [];
    var events = [];
    Object.entries(eventRecords).forEach(function (_ref9) {
      var _ref0 = _slicedToArray(_ref9, 2),
        _placeholderKey = _ref0[0],
        event = _ref0[1];
      events.push(event);
    });
    return events;
  } catch (_error) {
    return [];
  }
};
var onMessageFailedToSend = function onMessageFailedToSend(ticketKey, placeholderKey, placeholderMessageDto) {
  return function (dispatch) {
    dispatch(setTicketMessageStatus(ticketKey, placeholderKey, 'FAILED'));
    if (placeholderMessageDto) {
      saveFailedMessageEventToLocalStorage(ticketKey, placeholderKey, _objectSpread(_objectSpread({}, placeholderMessageDto), {}, {
        status: 'FAILED'
      }));
    }
  };
};
var onUploadAttachmentStageCompleted = function onUploadAttachmentStageCompleted(ticketKey, placeholderMessageKey, attachmentData) {
  return function (dispatch) {
    return dispatch({
      type: Actions.UPLOAD_FILE_STAGE_IN_SEND_TICKET_MESSAGE_FINISHED,
      ticketKey: ticketKey,
      placeholderKey: placeholderMessageKey,
      attachmentData: attachmentData
    });
  };
};
var getSenderDataForPlaceholderMessage = function getSenderDataForPlaceholderMessage(sender) {
  return {
    sender: sender,
    senderType: 'ACCOUNT'
  };
};
var mentionFilter = function mentionFilter(filterText, fullName) {
  return new RegExp('(^|\\s)' + escapeRegExp(filterText), 'i').test(fullName);
};
var getFullNamesMap = function getFullNamesMap(state, extensionKeys) {
  return extensionKeys.reduce(function (acc, extensionKey) {
    var fullName = getContactName(selectContact(state, extensionKey));
    var chatUserKey = selectChatUserKey(state, extensionKey);
    if (!fullName || !chatUserKey) return acc;
    return acc.set(extensionKey, Map({
      fullName: fullName,
      extensionKey: extensionKey,
      chatUserKey: chatUserKey
    }));
  }, Map());
};
var findMentionee = function findMentionee(fullNames, possibleMention) {
  var _loop = function _loop() {
      var filterText = possibleMention.substring(1, i);
      var filteredMentionees = fullNames.filter(function (mentionee) {
        return mentionFilter(filterText, mentionee.get('fullName'));
      });
      if (filteredMentionees.size > 1) {
        // If there are multiple possible matches, continue by adding another character
        return 0; // continue
      } else if (filteredMentionees.size === 0) {
        // If there are no matches, stop and try to find another possible mention
        return {
          v: undefined
        };
      }
      var mentionee = filteredMentionees.first();
      var mentioneeFullName = mentionee.get('fullName');
      if (mentioneeFullName.length !== filterText.length) {
        return 0; // continue
      }
      return {
        v: mentioneeFullName === filterText ? mentionee : undefined
      };
    },
    _ret;
  // Go through the possible mention, one more character at a time
  for (var i = 2; i <= possibleMention.length; i++) {
    _ret = _loop();
    if (_ret === 0) continue;
    if (_ret) return _ret.v;
  }
  return undefined;
};

// A pick applies only where the text still holds its "@name" at the index it
// was inserted at, so an edited name falls back to the search by name.
var findPickedMentionee = function findPickedMentionee(state, pickedMentions, text, mentionStart) {
  var pickedMention = pickedMentions.find(function (pick) {
    return pick.get('start') === mentionStart && text.startsWith("@".concat(pick.get('name')), mentionStart);
  });
  if (!pickedMention) return undefined;
  var extensionKey = pickedMention.get('extensionKey');
  var chatUserKey = selectChatUserKey(state, extensionKey);
  if (!chatUserKey) return undefined;
  return fromJS({
    fullName: pickedMention.get('name'),
    extensionKey: extensionKey,
    chatUserKey: chatUserKey
  });
};

// NOTE:
// This method is 90% copied from Flow-webapp/src/app/flow/utils/message-utils.js createMentionDTOsFromText.
// The difference: the colleagues picked in the mention picker come first. For
// a name typed by hand, when the visibility allows it, the search covers all
// extensions next. Thus "@Anna Bergman" does not stop at a member "Anna Berg".
// Then the members break a tie, so a member wins over a colleague with the
// same name.
var createMentionDTO = function createMentionDTO(state, ticketKey, text, pickedMentions) {
  var memberKeys = selectMembers(state, ticketKey);
  var nonMembersAreMentionable = selectNonMembersAreMentionable(state, ticketKey);
  var pickedMentionsAllowed = pickedMentions === null || pickedMentions === void 0 ? void 0 : pickedMentions.filter(function (pickedMention) {
    return nonMembersAreMentionable || (memberKeys === null || memberKeys === void 0 ? void 0 : memberKeys.has(pickedMention.get('extensionKey')));
  }).toList();
  var membersFullNames = getFullNamesMap(state, memberKeys);
  var extensionsFullNames = nonMembersAreMentionable ? getFullNamesMap(state, selectExtensions(state).keySeq().toSet()) : undefined;
  var mentions = List();
  var currentMentionPosition = text.length;
  var regexp = new RegExp(REGEXP_POSSIBLE_MENTION_STRICT);
  for (;;) {
    var _ref1, _ref10;
    // Find a possible mention
    var regexpResult = regexp.exec(text);
    if (regexpResult == null) {
      return mentions;
    }
    var possibleMention = regexpResult[1];
    currentMentionPosition -= possibleMention.length;
    var mentionee = (_ref1 = (_ref10 = pickedMentionsAllowed && findPickedMentionee(state, pickedMentionsAllowed, text, currentMentionPosition)) !== null && _ref10 !== void 0 ? _ref10 : extensionsFullNames && findMentionee(extensionsFullNames, possibleMention)) !== null && _ref1 !== void 0 ? _ref1 : findMentionee(membersFullNames, possibleMention);
    if (mentionee) {
      var length = mentionee.get('fullName').length + 1;
      var mentionDTO = fromJS({
        startPosition: currentMentionPosition,
        length: length,
        stylingReference: {
          stylingType: 'chatuser',
          chatUser: {
            key: mentionee.get('chatUserKey')
          }
        }
      });
      mentions = mentions.push(mentionDTO);
    }
    text = text.substring(0, currentMentionPosition);
  }
};
export var setTicketReplyDraft = function setTicketReplyDraft(ticketKey, replyType, text, mentions) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_REPLY_DRAFT,
      ticketKey: ticketKey,
      replyType: replyType,
      text: text,
      mentions: mentions
    });
  };
};